<template>
  <div class="card-content">
    <div class="type-list">
      <el-button type="primary" :plain='type != "card"' size="small" @click="handleChangeType('card')">阵列</el-button>
      <el-button type="primary" :plain='type == "card"' size="small" @click="handleChangeType('list')">清单</el-button>
    </div>
    <div class="card" v-if="type == 'card'">
      <el-row :gutter="12">
        <el-col :span="6" v-for="(item, index) in dataList" :key="item.id">
          <el-card class="card-item" shadow="hover">
            <div class="card-top">
              <div class="img">
                <img style="height: 80px" src="~@/assets/image/company-logo.png" alt="">
              </div>
              <div class="name">
                <p class="card-name">{{ item.name }}</p>
              </div>
              <div class="status">
                <el-button class="btn" type="primary" size="small" v-if="item.onOffStatus === true" >正常</el-button>
                <el-button class="btn" type="danger" size="small"  v-if="item.onOffStatus === false">异常</el-button>
                <br>
                <el-button class="btn" type="primary" size="small" v-if="!isSwitch" >告警</el-button>
              </div>
            </div>
            <div class="detail">
              <p>电流：<span>{{item.Ia}}</span> <span>{{item.Ib}}</span> <span>{{item.Ic}}</span></p>
              <p>电压：<span>{{item.Ua}}</span> <span>{{item.Ub}}</span> <span>{{item.Uc}}</span></p>
              <p>功率：<span>{{item.P}}</span> <span>{{item.Q}}</span> <span>{{item.S}}</span></p>
            </div>
            <el-button class="detail-btn" @click="handleDetail(index, item)">明细</el-button>
          </el-card>
        </el-col>
      </el-row>
    </div>
    <div class="table-content" v-else>
      <el-table ref="table" class="simple-table" :data="dataList" height="100%" highlight-current-row fit border >
        <el-table-column prop="name" :label="isSwitch?'开关':'房间'" align="left" min-width="160" show-overflow-tooltip></el-table-column>
        <el-table-column prop="Ua" label="A相电压" align="left" min-width="100" show-overflow-tooltip></el-table-column>
        <el-table-column prop="Ub" label="B相电压" align="left" min-width="100" show-overflow-tooltip></el-table-column>
        <el-table-column prop="Uc" label="C相电压" align="left" min-width="100" show-overflow-tooltip></el-table-column>
        <el-table-column prop="Ia" label="A相电流" align="left" min-width="100" show-overflow-tooltip></el-table-column>
        <el-table-column prop="Ib" label="B相电流" align="left" min-width="100" show-overflow-tooltip></el-table-column>
        <el-table-column prop="Ib" label="C相电流" align="left" min-width="100" show-overflow-tooltip></el-table-column>
        <el-table-column prop="P" label="总有功功率" align="left" min-width="100" show-overflow-tooltip></el-table-column>
        <el-table-column prop="Q" label="总无功功率" align="left" min-width="100" show-overflow-tooltip></el-table-column>
        <el-table-column prop="S" label="总视在功率" align="left" min-width="100" show-overflow-tooltip></el-table-column>
        <!-- <el-table-column prop="leaseEndTime" label="剩余电流" align="left" min-width="100" show-overflow-tooltip></el-table-column> -->
        <!-- <el-table-column prop="leaseEndTime" label="温度" align="left" min-width="100" show-overflow-tooltip></el-table-column> -->
        <el-table-column fixed="right" label="操作" align="left" min-width="100">
          <template slot-scope="scope">
            <el-button class="table-btn" @click.native.prevent="handleDetail(scope.$index, scope.row)" type="text" :size="sizeMini">详情</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <detail-dialog ref="detailDialog" v-if="detailDialogVisible"></detail-dialog>
  </div>
</template>

<script>
import detailDialog from './detailDialog.vue'
export default {
  name: 'cardContent',
  components: {
    detailDialog
  },
  props: {
    dataList: Array,
    // tableData: Array,
    isSwitch:  {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      detailDialogVisible: false,
      type: 'card'
    }
  },
  created () {
  },
  methods: {
    handleChangeType (val) {
      this.type = val
    },
    handleDetail (index, row) {
      this.detailDialogVisible = true
      this.$nextTick(() => {
        this.$refs.detailDialog.init(row, this.isSwitch)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.card-content {
  width: 100%;
  height: calc(100% - 166px);
  box-sizing: border-box;
}

.type-list {
  text-align: right;
}

.card,
.table-content {
  height: calc(100% - 40px);
  // border: 1px solid;
  padding: 8px;
  box-sizing: border-box;
}

.card-item {
  position: relative;
  padding: 8px;
  border: 1px solid #ddd;
  .card-top {
    width: 100%;
    display: flex;
    .name {
      width: calc(100% - 146px);
    }
    .status {
      width: 60px;
      word-break: normal;
      .btn {
        margin-bottom: 6px;
      }
    }
  }
  .detail {
    text-align: left;
  }
  .detail-btn {
    position: absolute;
    bottom: 8px;
    right: 8px;
  }
}
::v-deep .el-card__body {
  padding: 0;
}
</style>